// Vuex project module actions
import { API } from '@/config';

import { FILL_LIST, FILL_DETAILS } from './mutations-types';

export default {
  async removeAgent(context, params) {
    try {
      await API.delete('/project/agent/removeAgent', { params });
    } catch (err) {
      console.log(err);
    }
  },
  async updateAgentStatus(context, { newStatus, agent, actionId }) {
    try {
      const params = {
        status: newStatus,
        agent,
        action_id: actionId,
      };
      await API.patch('/project/agent/setStatus', { ...params });
    } catch (err) {
      console.log(err);
    }
  },
  async getList({ commit }, project) {
    try {
      const params = {
        project,
      };
      const { records, total } = (await API.get('project/agent/getList', { params })).data.data;
      commit(FILL_LIST, { records, total });
    } catch (e) {
      console.log(e);
    }
  },
  async getListByGroups({ commit }, groups) {
    try {
      const params = {
        groups,
      };
      const { records, total } = (await API.get('project/agent/getListByGroups', { params })).data.data;
      commit(FILL_LIST, { records, total });
    } catch (e) {
      console.log(e);
    }
  },

  async getDetails({ commit }, agent) {
    try {
      const params = { agent };
      const { record, total } = (await API.get('/project/agent/getDetails', { params })).data.data;
      commit(FILL_DETAILS, { record, total });
    } catch (e) {
      console.log(e);
    }
  },
  async updateAgent(context, params) {
    try {
      await API.patch('/project/agent/updateAgent', { ...params });
    } catch (err) {
      console.log(err);
    }
  },
};
